import { MathTanIcon } from './MathTanIcon';

/**
 * author: Michael Irigoyen
 * id 47194CCD-AF78-430F-AD95-4D564D6E1D18
 * name math-tan
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-tan.svg
 * tags
 * - Math 
 */
export const MathTangentIcon = MathTanIcon;
export default MathTangentIcon